import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers';

const configureStore = () => {
  const saga_middleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    applyMiddleware(saga_middleware, thunkMiddleware),
  );

  // expose saga run
  store.runSaga = saga_middleware.run;

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js